module.exports = __webpack_public_path__ + "static/media/ic_settings.e3b942a7.svg";